import { createContext, useContext, useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ReferenceContext = createContext(null);

const DEFAULTS = {
  carriers: [], products: [], states: [], sources: [], vendors: [],
  agents: [], callers: [], team: [],
};

export function ReferenceProvider({ children }) {
  const { user } = useAuth();
  const [opts, setOpts] = useState(DEFAULTS);
  const [users, setUsers] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const [refRes, userRes] = await Promise.all([
        api.get("/reference"),
        api.get("/users").catch(() => ({ data: [] })),
      ]);
      const grouped = { carriers: [], products: [], states: [], sources: [], vendors: [] };
      refRes.data.forEach((r) => {
        if (!grouped[r.type]) grouped[r.type] = [];
        if (r.active !== false) grouped[r.type].push(r.value);
      });
      const u = userRes.data || [];
      const active = u.filter((x) => x.active !== false);
      setUsers(u);
      setOpts({
        carriers: grouped.carriers, products: grouped.products, states: grouped.states,
        sources: grouped.sources, vendors: grouped.vendors,
        agents: active.filter((x) => ["admin", "ops_manager", "agent", "future"].includes(x.role)).map((x) => x.name),
        callers: active.filter((x) => ["admin", "ops_manager", "bpo"].includes(x.role)).map((x) => x.name),
        team: active.map((x) => x.name),
      });
    } catch {
      /* keep defaults */
    }
  }, []);

  useEffect(() => { if (user) refresh(); }, [user, refresh]);

  return <ReferenceContext.Provider value={{ opts, users, refresh }}>{children}</ReferenceContext.Provider>;
}

export const useReference = () => useContext(ReferenceContext) || { opts: DEFAULTS, users: [], refresh: () => {} };
